import { render, staticRenderFns } from "./ShipmentScriptView.vue?vue&type=template&id=747c7626&"
import script from "./ShipmentScriptView.vue?vue&type=script&lang=js&"
export * from "./ShipmentScriptView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports